/**
 * CSVアップロードのための列挙型。
 * @enum {Object}
 */
export const CsvUploadType = Object.freeze({
  /**
   * 作業指示データを表します。
   * @type {Object}
   */
  TASK: {
    csvNo: 'task',
    label: '作業指示データ',
    icon: 'icon_list_alt.svg',
    params: function (...args) {
      return {
        file: args[0],
        csvNo: args[1],
        taskType: args[2]
      }
    }
  },
  /**
   * 仕分けマスタを表します。
   * @type {Object}
   */
  SORTING: {
    csvNo: 'sorting',
    label: '仕分けマスタ',
    icon: 'icon_stacked_inbox.svg',
    params: function (...args) {
      return {
        file: args[0],
        csvNo: args[1],
        taskType: args[2]
      }
    }
  },
  /**
   * 商品マスタを表します。
   * @type {Object}
   */
  ITEM: {
    csvNo: 'item',
    label: '商品マスタ',
    icon: 'icon_shopping_mode.svg',
    params: function (...args) {
      return {
        file: args[0],
        csvNo: args[1]
      }
    }
  },
  /**
   * シュートマスタを表します。
   * @type {Object}
   */
  CHUTE: {
    csvNo: 'chute',
    label: 'シュートマスタ',
    icon: 'icon_inventory.svg',
    params: function (...args) {
      return {
        file: args[0],
        csvNo: args[1]
      }
    }
  },
  /**
   * 店舗マスタを表します。
   * @type {Object}
   */
  SHOP: {
    csvNo: 'shop',
    label: '店舗マスタ',
    icon: 'icon_store.svg',
    params: function (...args) {
      return {
        file: args[0],
        csvNo: args[1]
      }
    }
  },
  /**
   * ファイル名から取り込み先取得を表します。
   * @type {Object}
   */
  DEFAULT: {
    csvNo: 'default',
    label: 'ファイル名から取り込み先取得',
    icon: 'icon_document.svg',
    params: function (...args) {
      return {
        file: args[0]
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/enums/csv-upload-type.enums.js